import { ProjectsState } from './projects.types';

export const EMPTY_ARRAY_LENGTH = 0;
export const PROJECTS_FETCHING_ERROR_PREFIX = 'Error fetching projects';
export const PROJECT_REMOVAL_ERROR_PREFIX = 'Error removing project: ';

export const PROJECT_STATUSES = {
  OK: 'Ok',
  ARCHIVED: 'Archived',
  UNINITIALIZED: 'uninitialized',
  PARSING_DATA: 'Parsing data',
  UPLOADING_TO_DB: 'Uploading to db',
};

export const PROJECTS_INITIAL_STATE: ProjectsState = {
  data: [],
  loading: 'idle',
  error: { name: '', message: '' },
};
